// カートAPIのエラーを表示し、読み込み状態と合わせてログイン操作を制御する
export function initCartFeedback($, dialog, plain) {
  const $errors = $(dialog).find('.js-home-cart-errors');
  const $login = $(dialog).find('.js-home-cart-login');
  const $line = $login.filter('a');
  const lineHref = $line.attr('href');
  const $checkout = $login.filter('.js-home-cart-checkout');
  const checkoutHref = $checkout.attr('href');
  let hasCart = false;
  let emptyCart = true;
  let hasErrors = false;
  let busy = true;
  let failed = false;

  function updateLogin() {
    const disabled = busy || !hasCart || hasErrors || failed;
    $login.attr('aria-disabled', String(disabled));
    $login.filter('button').prop('disabled', disabled);
    $line.attr('href', disabled ? null : (lineHref ?? null));
    $checkout.attr('aria-disabled', String(disabled || emptyCart));
    $checkout.attr('href', disabled || emptyCart ? null : (checkoutHref ?? null));
  }

  // リンクはクリック・Enterのどちらでも無効状態を守る
  $login.on('click', function (event) {
    if ($(this).attr('aria-disabled') === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  });
  updateLogin();

  return {
    render(cart) {
      const errors = cart.errors || [];
      hasCart = true;
      emptyCart = !cart.items?.length;
      hasErrors = errors.length > 0;
      failed = false;
      // 句点ごとに改行し、購入できない理由と次の操作を分けて読みやすくする
      $errors.text(errors.map(error => plain(error.message).replace(/。\s*(?=\S)/g, '。\n')).join('\n')).prop('hidden', !hasErrors);
      updateLogin();
    },
    setBusy(value) {
      busy = value;
      updateLogin();
    },
    fail() {
      failed = true;
      updateLogin();
    },
  };
}
